import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-google-review",
  templateUrl: "./google-review.component.html",
  styleUrls: ["./google-review.component.scss"],
  standalone: false,
})
export class GoogleReviewComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
